import { Box, Card, CardContent, CardHeader, Grid, Typography, Divider, Chip } from "@mui/material";
import {
  CalendarToday,
  Description as DescriptionIcon,
  AccountBalance,
  CheckCircle,
  AttachMoney,
  Update,
  Money,
} from "@mui/icons-material";
import React from "react";
import { useMaterialUIController } from "context";
import { useTheme } from "@mui/material/styles";

// show journal entry details in modal
const JournalEntriesModal = ({ journalEntry }) => {
 const [controller] = useMaterialUIController();
   const darkMode = controller.darkMode;
   const theme = useTheme();
  return (
    <Box sx={{
        p: 3,
        width: "100%",
        bgcolor: darkMode ? theme.palette.background.default : "background.paper",
        borderRadius: 2,
        boxShadow: 3,
        color: darkMode ? "white !important" : "inherit",
      }}>
      <Typography variant="h5" sx={{ mb: 3,  }}>
        تفاصيل قيد اليومية: {journalEntry.number}
      </Typography>

      <Card variant="outlined" sx={{ mb: 4, boxShadow: 2 }}>
        <CardHeader
          title="معلومات عامة"
          titleTypographyProps={{ variant: "h6", color: "white" }}
          sx={{ backgroundColor: "gradients.primary.main" }}
        />
        <CardContent>
          <Grid container spacing={2}>
           <Grid item size={{ xs: 12, sm: 10 }}>
              <Typography variant="subtitle1" color="text.main" sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                <AccountBalance sx={{ mr: 1, color: "info.light" }} /> <strong>الفترة المالية:</strong>{" "}
                {journalEntry.fiscal_period_name}
              </Typography>
            </Grid>
            <Grid item size={{ xs: 12, sm: 2 }} >
              <Chip variant="filled" color={journalEntry.status === "draft" ? "#757575" : "info"}  label={journalEntry.status_name} sx={{ display: "flex", alignItems: "center", mb: 1 , bgcolor: journalEntry.status === "draft" ? "#757575" : "info.focus" }}>
                <CheckCircle
                  sx={{ mr: 1, color: journalEntry.status === "draft" ? "#757575" : "info.focus" }}
                />
                 {journalEntry.status_name}
              </Chip>
            </Grid>
            <Grid item size={{ xs: 12 }}>
              <Typography variant="subtitle1" color="text.main" sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                <DescriptionIcon sx={{ mr: 1, color: "info.light" }} /> <strong>الوصف:</strong>{" "}
                {journalEntry.description}
              </Typography>
            </Grid>
            
            <Grid item size={{ xs: 12, sm: 6 }}>
              <Typography variant="subtitle1" color="text.main" sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                <AttachMoney sx={{ mr: 1, color: "info.light" }} /> <strong>إجمالي المدين:</strong>{" "}
                <span >{journalEntry.total_debit} </span>
              </Typography>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6 }}>
              <Typography variant="subtitle1" color="text.main" sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                <Money sx={{ mr: 1, color: "info.light" }} /> <strong >إجمالي الدائن:</strong>{" "}
                  <span >{journalEntry.total_credit} </span>
              </Typography>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6 }}>
              <Box variant="subtitle1" color="text.main" sx={{ display: "flex" , alignItems: "center", mb: 1 }}>
                <Update sx={{ mr: 1, color: "info.light" }}  /> <strong>تاريخ الإنشاء:</strong>{" "}
                <Typography variant="subtitle1" color="text.main" sx={{ display: "flex",fontSize: 14 , alignItems: "center", mb: 1 }}>
                {journalEntry.created_at}
                </Typography>
              </Box>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6 }}>
              <Box variant="subtitle1" color="text.main" sx={{ display: "flex" , alignItems: "center", mb: 1 }}>
                <Update sx={{ mr: 1, color: "info.light" }} /> تاريخ التحديث:
                <Typography variant="subtitle1" color="text.main" sx={{ display: "flex",fontSize: 14 , alignItems: "center", mb: 1 }}>
                {journalEntry.updated_at}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      <Typography variant="h6" sx={{ mb: 2, color: "text.main" }}>
        التفاصيل:
      </Typography>
      <Divider sx={{ mb: 2 }} />
      <Grid display="flex" gap={2}>
        {journalEntry.details.map((detail) => (
          <Grid item flex={1} key={detail.id}>
            <Card variant="outlined" sx={{ boxShadow: 2 }}>
              <CardHeader
                title={`حساب: ${detail.account_name}`}
                subheader={`كود: ${detail.account_code}`}
                titleTypographyProps={{ variant: "subtitle1" }}
                subheaderTypographyProps={{ variant: "body2" }}
                sx={{ backgroundColor: "#A9D5D6" }}
              />
              <CardContent>
                <Grid container spacing={2}>
                  <Grid item sx={{xs: 12, sm: 6}}>
                    <Typography
                      variant="body1"
                      sx={{ color: detail.debit_amount > 0 ? "#4caf50" : "text.border" }}
                    >
                      <strong>مدين:</strong> {detail.debit_amount}
                    </Typography>
                  </Grid>
                  <Grid item sx={{xs:12 , sm: 6}}>
                    <Typography
                      variant="body1"
                      sx={{ color: detail.credit_amount > 0 ? "#f44336" : "text.border" }}
                    >
                      <strong>دائن:</strong> {detail.credit_amount}
                    </Typography>
                  </Grid>
                </Grid>
                <Typography variant="body1" sx={{ mt: 1 , color: "text.main"}}>
                  <strong>الوصف:</strong> {detail.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default JournalEntriesModal;
